//import React, { useState, useEffect, useCallback } from 'react';
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './OrderHistory.css';

function OrderHistory({ onBack }) {
  const [orders, setOrders] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);

  // Filter states
  const [selectedCustomerId, setSelectedCustomerId] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('all');

//  const salesmanID = localStorage.getItem('employeeID') || 1;
  const companyID = localStorage.getItem('companyID');

  // Load customers once
  useEffect(() => {
    const loadCustomers = async () => {
      try {
        const res = await api.getCustomers(companyID);
        if (res.data.success) {
          setCustomers(res.data.customers);
        }
      } catch (err) {
        console.error('Failed to load customers', err);
      }
    };
    loadCustomers();
  }, [companyID]); // ✅ dependency: companyID

  // Fetch orders whenever filters change
  useEffect(() => {
   const fetchOrders = async () => {
  setLoading(true);
  setError('');
  try {
    const status = selectedStatus !== 'all' ? selectedStatus : null;
    const customerId = selectedCustomerId !== '' ? selectedCustomerId : null;
    // No salesmanID needed
    const response = await api.getOrderHistory(companyID, customerId, status, 100);
    if (response.data.success) {
      setOrders(response.data.orders);
    } else {
      setError(response.data.error || 'Failed to fetch orders');
    }
  } catch (err) {
    console.error(err);
    setError(err.message || 'Network error');
  } finally {
    setLoading(false);
  }
};

    fetchOrders();
  }, [selectedCustomerId, selectedStatus, companyID]); // ✅ all dependencies

  const handleViewDetails = async (orderId) => {
    setModalLoading(true);
    try {
      const response = await api.getOrderDetails(orderId, companyID);
      if (response.data.success) {
        setSelectedOrder(response.data);
      } else {
        alert(response.data.error || 'Could not load order details');
      }
    } catch (err) {
      console.error(err);
      alert('Error loading details');
    } finally {
      setModalLoading(false);
    }
  };

  const closeModal = () => setSelectedOrder(null);

  const handleResetFilters = () => {
    setSelectedCustomerId('');
    setSelectedStatus('all');
  };

  // Loading initial state
  if (loading && orders.length === 0)
    return <div className="history-loading">Loading orders...</div>;

  return (
    <div className="order-history-container">
      <header className="history-header">
        <button className="back-btn" onClick={onBack}>← Back to Dashboard</button>
        <h2>My Order History</h2>
      </header>

      {/* Filters Section */}
      <div className="filters-bar">
        <div className="filter-group">
          <label>Customer:</label>
          <select
            value={selectedCustomerId}
            onChange={(e) => setSelectedCustomerId(e.target.value)}
          >
            <option value="">All Customers</option>
            {customers.map(cust => (
              <option key={cust.customerID} value={cust.customerID}>
                {cust.customerName}
              </option>
            ))}
          </select>
        </div>

        <div className="filter-group">
          <label>Status:</label>
          <select
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
          >
            <option value="all">All</option>
            <option value="preparing">Preparing</option>
            <option value="to ship">To Ship</option>
            <option value="delivered">Delivered</option>
            <option value="confirmed">Confirmed</option>
            <option value="cancelled">Cancelled</option>
          </select>
        </div>

        <button className="reset-btn" onClick={handleResetFilters}>
          Reset
        </button>
      </div>

      {error && <div className="history-error">{error}</div>}

      {orders.length === 0 && !loading && (
        <p className="no-orders">No orders found for selected filters.</p>
      )}

      {loading && <p>Updating orders...</p>}

      <div className="orders-list">
        {orders.map(order => (
          <div key={order.id} className="order-card">
            <div className="order-info">
              <div className="order-number">Order #{order.order_no}</div>
              <div className="order-date">{new Date(order.order_date).toLocaleDateString()}</div>
              <div className="order-total">RM {parseFloat(order.total_amount).toFixed(2)}</div>
              <div className={`order-status ${order.status}`}>{order.status}</div>
            </div>
            <button
              className="view-detail-btn"
              onClick={() => handleViewDetails(order.id)}
            >
              View Detail
            </button>
          </div>
        ))}
      </div>

      {/* Modal (unchanged) */}
      {selectedOrder && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>×</button>
            {modalLoading ? (
              <p>Loading details...</p>
            ) : (
              <>
                <h3>Order Details</h3>
                <div className="detail-row"><strong>Order No:</strong> {selectedOrder.order?.order_no}</div>
                <div className="detail-row"><strong>Date:</strong> {new Date(selectedOrder.order?.order_date).toLocaleString()}</div>
                <div className="detail-row"><strong>Customer ID:</strong> {selectedOrder.order?.customerID}</div>
                <div className="detail-row"><strong>Status:</strong> {selectedOrder.order?.status}</div>
                <div className="detail-row"><strong>Total Amount:</strong> RM {parseFloat(selectedOrder.order?.total_amount || 0).toFixed(2)}</div>
                <div className="detail-row"><strong>Tax:</strong> RM {parseFloat(selectedOrder.order?.tax_amount || 0).toFixed(2)}</div>
                <div className="detail-row"><strong>Remarks:</strong> {selectedOrder.order?.remarks || '—'}</div>
                <h4>Items</h4>
                {selectedOrder.items?.length === 0 ? (
                  <p>No items found.</p>
                ) : (
                  <table className="items-table">
                    <thead>
                      <tr>
                        <th>Product</th>
                        <th>Qty</th>
                        <th>Price</th>
                        <th>Subtotal</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedOrder.items?.map((item, idx) => (
                        <tr key={idx}>
                          <td>{item.productName || `Product ID: ${item.productID}`}</td>
                          <td>{item.quantity}</td>
                          <td>RM {parseFloat(item.price).toFixed(2)}</td>
                          <td>RM {parseFloat(item.total).toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default OrderHistory;